import React from 'react';
import { Field } from 'formik';

const { fundTypeNames } = require('buyside/util/constantsFromRails.json');
import CheckboxesField from 'buyside/components/presentation/Form/Field/CheckboxesField/checkboxesField';

const FirmExperience = ({ isMobile }) => (
  <Field
    component={CheckboxesField}
    name="minimum.firmExperience"
    options={fundTypeNames}
    numColumns={isMobile ? 2 : 3}
  />
);

export default FirmExperience;
